// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    commonGetApiV1Time (params?: {}): Promise<Dict>;
    commonGetApiV1Ping (params?: {}): Promise<Dict>;
    commonGetApiV1ExchangeInfo (params?: {}): Promise<Dict>;
    commonGetQuoteV1Depth (params?: {}): Promise<Dict>;
    commonGetQuoteV1DepthMerged (params?: {}): Promise<Dict>;
    commonGetQuoteV1Trades (params?: {}): Promise<List>;
    commonGetQuoteV1Klines (params?: {}): Promise<List>;
    commonGetQuoteV1IndexKlines (params?: {}): Promise<List>;
    commonGetQuoteV1IndexPriceComponents (params?: {}): Promise<Dict>;
    commonGetQuoteV1MarkPriceKlines (params?: {}): Promise<List>;
    commonGetQuoteV1MarkPrice (params?: {}): Promise<Dict>;
    commonGetQuoteV1Index (params?: {}): Promise<Dict>;
    commonGetQuoteV1Ticker24hr (params?: {}): Promise<List>;
    commonGetQuoteV1ContractTicker24hr (params?: {}): Promise<List>;
    commonGetQuoteV1TickerPrice (params?: {}): Promise<List>;
    commonGetQuoteV1ContractTickerPrice (params?: {}): Promise<List>;
    commonGetQuoteV1TickerBookTicker (params?: {}): Promise<List>;
    commonGetQuoteV1ContractTickerBookTicker (params?: {}): Promise<List>;
    commonGetApiV1FuturesFundingRate (params?: {}): Promise<List>;
    commonGetApiV1FuturesHistoryFundingRate (params?: {}): Promise<List>;
    commonGetApiV1FuturesRiskLimits (params?: {}): Promise<List>;
    privateGetApiV1Account (params?: {}): Promise<Dict>;
    privateGetApiV1AccountCheckApiKey (params?: {}): Promise<Dict>;
    privateGetApiV1SpotOrder (params?: {}): Promise<Dict>;
    privateGetApiV1SpotOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1SpotTradeOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesHistoryOrders (params?: {}): Promise<List>;
    privateGetApiV1AccountTrades (params?: {}): Promise<List>;
    privateGetApiV1AccountBalanceFlow (params?: {}): Promise<List>;
    privateGetApiV1AccountDepositOrders (params?: {}): Promise<List>;
    privateGetApiV1AccountWithdrawOrders (params?: {}): Promise<List>;
    privateGetApiV1AccountDepositAddress (params?: {}): Promise<Dict>;
    privateGetApiV1SubAccount (params?: {}): Promise<List>;
    privateGetApiV1AccountSubAccount (params?: {}): Promise<List>;
    privateGetApiV1SubAccountList (params?: {}): Promise<List>;
    privateGetApiV1FuturesAccountLeverage (params?: {}): Promise<Dict>;
    privateGetApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privateGetApiV1FuturesPositions (params?: {}): Promise<List>;
    privateGetApiV1FuturesHistoryPositions (params?: {}): Promise<List>;
    privateGetApiV1FuturesBalance (params?: {}): Promise<List>;
    privateGetApiV1FuturesUserTrades (params?: {}): Promise<List>;
    privateGetApiV1FuturesBalanceFlow (params?: {}): Promise<List>;
    privateGetApiV1FuturesCommissionRate (params?: {}): Promise<Dict>;
    privateGetApiV1FuturesTodayPnl (params?: {}): Promise<Dict>;
    privateGetApiV1AccountDownloadDetail (params?: {}): Promise<Dict>;
    privateGetApiV1AgentInviteUserList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentCommissionDataList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentCommissionDataInfo (params?: {}): Promise<Dict>;
    privateGetApiV1AgentInviteRelationCheck (params?: {}): Promise<Dict>;
    privateGetApiV1AgentDepositDetailList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentQuerySubAgentData (params?: {}): Promise<Dict>;
    privateGetApiV1AgentSpotOrdersList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentFuturesOrdersList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentFuturesPositionsList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentInviteCommissionDetail (params?: {}): Promise<Dict>;
    privateGetApiV1AgentUserExport (params?: {}): Promise<Dict>;
    privateGetApiV1AgentExportList (params?: {}): Promise<Dict>;
    privateGetApiV1AgentExportUrl (params?: {}): Promise<Dict>;
    privatePostApiV1SpotOrderTest (params?: {}): Promise<Dict>;
    privatePostApiV1SpotOrder (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privatePostApiV1SpotBatchOrders (params?: {}): Promise<Dict>;
    privatePostApiV1SubAccountTransfer (params?: {}): Promise<Dict>;
    privatePostApiV1AccountWithdraw (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesMarginType (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesLeverage (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesBatchOrders (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesPositionTradingStop (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesPositionMargin (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesOrderUpdate (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesAutoAddMargin (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesFlashClose (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesReversePosition (params?: {}): Promise<Dict>;
    privatePostApiV1AccountDownloadApply (params?: {}): Promise<Dict>;
    privatePostApiV1UserDataStream (params?: {}): Promise<Dict>;
    privatePostApiV1ListenKey (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotOrder (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotOpenOrders (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesBatchOrders (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotCancelOrderByIds (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesCancelOrderByIds (params?: {}): Promise<Dict>;
    privateDeleteApiV1UserDataStream (params?: {}): Promise<Dict>;
    privateDeleteApiV1ListenKey (params?: {}): Promise<Dict>;
    privatePutApiV1UserDataStream (params?: {}): Promise<Dict>;
    privatePutApiV1ListenKey (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
